import React, { useEffect, useState } from 'react';
import {
  Edit,
  TabbedForm,
  FormTab,
  required,
  TextInput,
  SelectInput,
  FileInput,
  useDataProvider,
} from 'react-admin';

import { TinyMCEEditor } from 'Components/Inputs';
import { booleanInteger, evidenceType, status, uploadChoice } from '../../utils/choices';
import { EvidenceFormStyles, formStyles } from '../../styles';
import { PreviewFileField, ActionButton } from 'Components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-solid-svg-icons';
import EvidenceImageInput, { validateEvidenceImage } from './ImageUploadInput';

const EvidenceEdit = (props) => {
  const classes = EvidenceFormStyles();
  const buttonClass = formStyles();
  const [evidence, setEvidence] = useState();
  const { resource, id } = props;
  const [templates, setTemplates] = useState([]);
  const dataProvider = useDataProvider();
  const [evidencePdf, setEvidencePdf] = useState();
  const [uploadChoiceValue, setUploadChoiceValue] = useState(uploadChoice[0].id);

  const handlePdfLiveView = () => {
    window.open(evidencePdf)
  }
  useEffect(() => {
    dataProvider
      .getOne('evidence', { id })
      .then(({ data }) => {
        setEvidence(data);
        setEvidencePdf(data.pdf?.url);
        setUploadChoiceValue(data.uploadChoice);
      })
      .catch((error) => {
        console.log('here', error);
      });
    dataProvider
      .getList('template', {})
      .then(({ data }) => {
        const templateData = data.map(({ id, name, template }) => ({ id, name, template }));
        setTemplates(templateData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <Edit {...props} title={`resources.${resource}.titles.edit`} >
      <TabbedForm>
        <FormTab label="Editor">
          <div className={classes.main}>
            <TextInput
              source="name"
              label="Evidence Name"
              validate={required()}
            />
            <SelectInput
              source="type"
              choices={evidenceType}
              validate={required()}
            />
            <SelectInput
              source="status"
              choices={status}
              validate={required()}
            />
            <TextInput label="Plot" source="plotId.name" disabled />
            <SelectInput
              source="uploadChoice"
              label="Upload Choice"
              choices={uploadChoice}
              validate={required()}
              disabled
            />

            {
              uploadChoiceValue === 'VIDEO' && <SelectInput
                source="videoEvidenceLoop"
                label="Loop video evidence"
                choices={booleanInteger}
                validate={required()}
                defaultValue={1}
              />
            }

          </div>
          {
            evidencePdf ? <ActionButton
              label={
                uploadChoiceValue === 'IMAGE'
                  ? 'View Image'
                  : uploadChoiceValue === 'EDITOR' || uploadChoiceValue === 'PDF'
                    ? 'View PDF'
                    : 'View Video'
              }
              onClick={handlePdfLiveView}
              style={{ width: 'auto' }}
              icon={<FontAwesomeIcon icon={faEye} />}
            /> : null
          }

          {evidence?.uploadChoice === uploadChoice[0].id && <TinyMCEEditor source="content" templates={templates} editorWidth='802px' />}
          {evidence?.uploadChoice === uploadChoice[1].id && <FileInput
            source="pdf"
            label="Upload Pdf File"
            accept="application/pdf"
            placeholder={<p>Drop your file here</p>}>
            <PreviewFileField title={`resources.${resource}.fields.pdf`} />
          </FileInput>
          }
          {evidence?.uploadChoice === uploadChoice[2].id && <FileInput
            source="video"
            label="Upload Video File"
            accept="video/*"
            placeholder={<p>Drop your file here</p>}>
            <PreviewFileField title={`resources.${resource}.fields.pdf`} />
          </FileInput>
          }
          {evidence?.uploadChoice === 'IMAGE' && (
            <EvidenceImageInput
              source="pdf"
              validate={validateEvidenceImage}
            />
          )}
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};

export default EvidenceEdit;
